import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThroughputDashboard } from './pages/ThroughputDashboard';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Navigate to="/throughput-dashboard" replace data-id="element-3" />} data-id="element-2" />
        <Route path="/throughput-dashboard" element={<ThroughputDashboard data-id="element-5" />} data-id="element-4" />
      </Routes>
    </Router>;
}